/**
 * @generated
 * This is an auto-generated file.
 * Do not modify it manually.
 */
import { css } from 'lit';

export const colorVariables = css`
  :host {
    --vn-skeleton-effect-foreground-color__shape: #e8e8e880;
    --vn-skeleton-effect-background-color__shape: #e8e8e8;
    --vn-skeleton-effect-foreground-color__header: #e8e8e880;
    --vn-skeleton-effect-background-color__header: #e8e8e8;
    --vn-skeleton-effect-foreground-color__text: #e8e8e840;
    --vn-skeleton-effect-background-color__text: #e8e8e880;
    --vn-skeleton-background-color__container: #ffffff;
    --vn-skeleton-stroke-color__container: #e8e8e8;
  }
  :host([mode='dark']) {
    --vn-skeleton-effect-foreground-color__shape: #3d3d3d80;
    --vn-skeleton-effect-background-color__shape: #3d3d3d;
    --vn-skeleton-effect-foreground-color__header: #3d3d3d80;
    --vn-skeleton-effect-background-color__header: #3d3d3d;
    --vn-skeleton-effect-foreground-color__text: #3d3d3d40;
    --vn-skeleton-effect-background-color__text: #3d3d3d80;
    --vn-skeleton-background-color__container: #212121;
    --vn-skeleton-stroke-color__container: #525252;
  }
  :host([mode='contrast']) {
    --vn-skeleton-effect-foreground-color__shape: #52525280;
    --vn-skeleton-effect-background-color__shape: #525252;
    --vn-skeleton-effect-foreground-color__header: #52525280;
    --vn-skeleton-effect-background-color__header: #525252;
    --vn-skeleton-effect-foreground-color__text: #52525240;
    --vn-skeleton-effect-background-color__text: #52525280;
    --vn-skeleton-background-color__container: #16141d;
    --vn-skeleton-stroke-color__container: #adadad;
  }
`;
